export default __webpack_public_path__ + "static/media/contact.a3b5cb44.svg";